<template>
    <div class="main">
        <div class="tts">
            <div class="container">
                <div class="nav">
                    <span class="active">语音转文字</span>
                </div>
                <div class="contents">
                    <div class="contenttext">
                        <p class="inputtext">上传音频文件（支持 wav、mp3 等，建议 16kHz 及以上采样率）</p>
                        <div class="uploadclass">
                            <el-upload
                                class="upload-demo"
                                :action="uploadAction"
                                :headers="uploadHeaders"
                                name="audio"
                                :data="{ language: language }"
                                :on-success="onUploadSuccess"
                                :on-error="onUploadError"
                                :before-upload="beforeUpload"
                                :show-file-list="false"
                                accept="audio/*,.wav,.mp3,.m4a">
                                <el-button type="primary" :loading="recognizing" :disabled="recognizing">
                                    {{ recognizing ? '识别中…' : '选择并识别' }}
                                </el-button>
                            </el-upload>
                        </div>
                        <template v-if="!resultText && pendingSttId">
                            <p class="inputtext">{{ sttPendingSummary }}</p>
                            <el-button type="primary" @click="openPayDialog">{{ actionButtonText }}</el-button>
                        </template>
                        <template v-else>
                            <p class="inputtext">识别结果：</p>
                            <textarea
                                class="wenben result-area"
                                v-model="resultText"
                                placeholder="支付后将显示识别结果，也可直接编辑"
                                rows="12"></textarea>
                            <div class="btn">
                                <el-button type="primary" icon="el-icon-document-copy" @click="copyResult">复制结果</el-button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="right" v-loading="false">
                <el-collapse accordion>
                    <el-collapse-item title="识别语言" :name="1">
                        <template slot="title">
                            <span class="collapse-title-with-icon"><i class="el-icon-s-flag"></i> 识别语言</span>
                        </template>
                        <el-select v-model="language" class="select" placeholder="选择语言">
                            <el-option label="中文（普通话）" value="zh-CN"></el-option>
                            <el-option label="英语（美国）" value="en-US"></el-option>
                            <el-option label="英语（英国）" value="en-GB"></el-option>
                            <el-option label="日语" value="ja-JP"></el-option>
                            <el-option label="韩语" value="ko-KR"></el-option>
                            <el-option label="自动检测" value="auto"></el-option>
                        </el-select>
                    </el-collapse-item>
                </el-collapse>
                <div class="toptip right-tip">
                    <div class="tishi">使用说明</div>
                    <div class="tishitip">1. 点击「选择并识别」上传音频，识别完成后显示字数与所需金币。</div>
                    <div class="tishitip">{{ usageTipLine2 }}</div>
                    <div class="tishitip">3. 建议使用清晰的语音，格式支持 wav、mp3 等。</div>
                </div>
            </div>
        </div>
        <div class="toptip">
            <div class="tishi">温馨提示</div>
            <div class="tishitip">本工具使用微软 Azure 语音识别服务，与「微软文字转语音」共用同一服务。如有问题请<el-link @click="$store.commit('SetOpenContactDialog', true)" type="primary">联系我们</el-link>。</div>
        </div>

        <!-- 未登录提示 -->
        <el-dialog title="查看结果提示" :visible.sync="showLoginPrompt" width="400px" center>
            <p class="qqtext">{{ loginPromptText }}</p>
            <span slot="footer">
                <el-button type="primary" @click="goLogin">去登录</el-button>
                <el-button @click="goRegister">去注册</el-button>
                <el-button @click="showLoginPrompt = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 选择支付方式：复用统一组件 -->
        <CoinChoiceDialog
            :visible.sync="showCoinChoiceDialog"
            :dialog-title="coinDialogTitle"
            title-icon="el-icon-document"
            :char-count="pendingSttCharCount"
            :coins-required="sttCoinsRequired"
            :rule-text="coinDialogRuleText"
            :primary-button-text="coinDialogPrimaryText"
            char-label=""
            @use-coin="chooseUseCoin"
            @watch-video="chooseWatchVideo"
            @pay-direct="choosePayDirect"
        />
        <!-- 支付二维码 -->
        <el-dialog center :before-close="function(){}" :show-close="false" :visible.sync="showPayDialog" width="680px">
            <pay :img="qrimg" :money="payMoney" :paytype="currentPayType"></pay>
            <span slot="footer">
                <el-button type="info" @click="paystatus" plain>已完成支付</el-button>
                <el-button type="info" @click="paystatus" plain>支付遇到问题</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import pay from './pay.vue'
import CoinChoiceDialog from './CoinChoiceDialog.vue'
export default {
    name: 'Speech2text',
    components: { pay, CoinChoiceDialog },
    data() {
        return {
            language: 'zh-CN',
            resultText: '',
            recognizing: false,
            uploadAction: '',
            uploadHeaders: {},
            pendingSttCharCount: 0,
            pendingSttId: '',
            showLoginPrompt: false,
            showCoinChoiceDialog: false,
            showPayDialog: false,
            qrimg: '',
            payMoney: 0.1,
            paymentOrderNo: '',
            isSttPayment: false,
            currentPayType: 'wepay',
            pricePerCoin: 0.1
        }
    },
    computed: {
        sttCoinsRequired() {
            const n = this.pendingSttCharCount || 0
            return Math.max(1, Math.ceil(n / 200))
        },
        coinChargeEnabled() {
            return this.$store.state.coinChargeEnabled !== false
        },
        sttPendingSummary() {
            if (!this.coinChargeEnabled) {
                return `识别完成，共 ${this.pendingSttCharCount} 字。当前为限时免费模式，登录后可直接查看结果。`
            }
            return `识别完成，共 ${this.pendingSttCharCount} 字，需 ${this.sttCoinsRequired} 金币（每200字1金币）。请选择支付方式查看结果。`
        },
        actionButtonText() {
            return this.coinChargeEnabled ? '去支付 / 查看结果' : '查看结果'
        },
        usageTipLine2() {
            return this.coinChargeEnabled
                ? '2. 每200字1金币，可选择抵扣金币、扫码看视频赚金币或直接付款后查看结果。'
                : '2. 当前为限时免费模式，登录后可直接查看结果，不扣金币。'
        },
        loginPromptText() {
            return this.coinChargeEnabled
                ? '请先登录或注册后再查看识别结果。查看结果按字数扣金币：每200字1金币。'
                : '请先登录或注册后再查看识别结果。当前为限时免费模式，登录后不扣金币。'
        },
        coinDialogTitle() {
            return this.coinChargeEnabled ? '选择支付方式' : '查看结果'
        },
        coinDialogRuleText() {
            return this.coinChargeEnabled ? '每200字1金币' : '当前为限时免费模式，本次不扣金币'
        },
        coinDialogPrimaryText() {
            return this.coinChargeEnabled ? '抵扣金币查看' : '直接查看结果'
        }
    },
    created() {
        const base = this.$store.state.basicurl || ''
        this.uploadAction = base.replace(/\/$/, '') + '/speech2text'
        const token = this.$store.state.user && this.$store.state.user.token
        if (token) {
            this.uploadHeaders = { Authorization: 'Bearer ' + token }
        }
    },
    methods: {
        beforeUpload(file) {
            const isAudio = /audio\/|\.(wav|mp3|m4a)$/i.test(file.type || file.name)
            if (!isAudio) {
                this.$message.warning('请上传音频文件（wav、mp3、m4a 等）')
                return false
            }
            const max = 25 * 1024 * 1024
            if (file.size > max) {
                this.$message.warning('文件大小不能超过 25MB')
                return false
            }
            this.recognizing = true
            return true
        },
        onUploadSuccess(res) {
            this.recognizing = false
            if (res && res.charCount != null && res.sttId) {
                this.pendingSttCharCount = res.charCount
                this.pendingSttId = res.sttId
                this.resultText = ''
                const user = this.$store.state.user
                if (!user) {
                    this.showLoginPrompt = true
                    this.$message.success(this.coinChargeEnabled ? '识别完成，请登录后选择支付方式查看结果' : '识别完成，请登录后直接查看结果')
                } else {
                    if (this.coinChargeEnabled) {
                        this.showCoinChoiceDialog = true
                        this.$message.success('识别完成，请选择支付方式查看结果')
                    } else {
                        this.$message.success('识别完成，正在为您加载结果')
                        this.chooseUseCoin()
                    }
                }
                return
            }
            if (res && res.message) {
                this.$message.warning(res.message)
            } else {
                this.$message.warning('识别失败，请重试')
            }
        },
        onUploadError(err) {
            this.recognizing = false
            const msg = (err.message || err.response && err.response.data && err.response.data.message) || '识别失败，请重试'
            this.$message.error(msg)
        },
        openPayDialog() {
            if (!this.$store.state.user) {
                this.showLoginPrompt = true
                return
            }
            if (!this.coinChargeEnabled) {
                this.chooseUseCoin()
                return
            }
            this.showCoinChoiceDialog = true
        },
        goLogin() {
            this.showLoginPrompt = false
            this.$store.commit('SetShowLoginDialog', { show: true, tab: 'login' })
        },
        goRegister() {
            this.showLoginPrompt = false
            this.$store.commit('SetShowLoginDialog', { show: true, tab: 'register' })
        },
        chooseUseCoin() {
            if (!this.pendingSttId) return
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) {
                this.$message.warning('请先登录')
                return
            }
            const required = this.sttCoinsRequired
            this.$axios.post('/speech2text/release', {
                token,
                sttId: this.pendingSttId,
                payMethod: 'coin'
            }, { headers: { Authorization: 'Bearer ' + token } }).then(r => {
                if (r.data && r.data.text != null) {
                    this.resultText = r.data.text
                    if (r.data.coins != null) this.$store.commit('SetUserCoins', r.data.coins)
                    this.pendingSttId = ''
                    this.showCoinChoiceDialog = false
                    if (this.coinChargeEnabled) this.$message.success('已扣除 ' + required + ' 金币，可查看结果')
                    else this.$message.success('当前为限时免费模式，可直接查看结果')
                }
            }).catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message) || err.message || '操作失败'
                this.$message.warning(msg)
            })
        },
        chooseWatchVideo() {
            this.showCoinChoiceDialog = false
            this.$store.commit('SetOpenEarnCoinDialog', true)
            this.$message.info('获取金币后可再次点击「去支付 / 查看结果」')
        },
        choosePayDirect(payType) {
            if (!this.pendingSttId) return
            const method = payType === 'wechat' ? 'wechat' : 'alipay'
            const amount = (this.sttCoinsRequired * this.pricePerCoin).toFixed(2)
            this.showCoinChoiceDialog = false
            this.isSttPayment = true
            this.currentPayType = payType === 'wechat' ? 'wepay' : 'alipay'
            this.$axios.post('/qrpayment', {
                money: Number(amount),
                subject: '语音转文字',
                payType: method,
                sttId: this.pendingSttId
            }).then(res => {
                if (res.data && (res.data.code === 'WECHAT_NOT_AVAILABLE' || res.data.code === 'WECHAT_ORDER_FAIL' || res.data.code === 'WECHAT_ORDER_ERROR')) {
                    this.$message.warning(res.data.message || '支付暂不可用')
                    this.isSttPayment = false
                    return
                }
                this.payMoney = Number(amount)
                this.qrimg = res.data.filename
                this.paymentOrderNo = res.data.out_trade_no || res.data.orderid
                this.showPayDialog = true
            }).catch(err => {
                this.isSttPayment = false
                this.$message.warning((err.response && err.response.data && err.response.data.message) || err.message || '支付请求失败')
            })
        },
        paystatus() {
            this.showPayDialog = false
            if (!this.paymentOrderNo) return
            this.$axios.post('/queryOrder', { out_trade_no: this.paymentOrderNo }).then(res => {
                if (res.data === '交易完成') {
                    if (this.isSttPayment && this.pendingSttId) {
                        const token = this.$store.state.user && this.$store.state.user.token
                        this.$axios.post('/speech2text/release', {
                            token: token || '',
                            sttId: this.pendingSttId,
                            payMethod: 'orderId',
                            orderId: this.paymentOrderNo
                        }, { headers: token ? { Authorization: 'Bearer ' + token } : {} }).then(r => {
                            if (r.data && r.data.text != null) {
                                this.resultText = r.data.text
                                this.pendingSttId = ''
                                this.$message.success('支付成功，可查看结果')
                            }
                        }).catch(() => {
                            this.$message.warning('获取结果失败，若已扣款请联系客服')
                        })
                    }
                    this.isSttPayment = false
                } else {
                    this.$message.warning(res.data || '未检测到支付完成')
                }
            }).catch(() => {
                this.$message.warning('查询支付状态失败')
            })
        },
        copyResult() {
            if (!this.resultText) {
                this.$message.warning('暂无内容可复制')
                return
            }
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(this.resultText).then(() => {
                    this.$message.success('已复制到剪贴板')
                }).catch(() => this.fallbackCopy())
            } else {
                this.fallbackCopy()
            }
        },
        fallbackCopy() {
            const ta = document.createElement('textarea')
            ta.value = this.resultText
            ta.style.position = 'fixed'
            ta.style.opacity = 0
            document.body.appendChild(ta)
            ta.select()
            try {
                document.execCommand('copy')
                this.$message.success('已复制到剪贴板')
            } catch (e) {
                this.$message.warning('复制失败，请手动选择复制')
            }
            document.body.removeChild(ta)
        }
    }
}
</script>

<style lang="less" scoped>
.main {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}
.tts {
    display: flex;
    align-items: stretch;
}
.container {
    flex: 1;
    min-width: 0;
}
.nav {
    margin-bottom: 10px;
}
.nav .active {
    font-weight: 600;
    color: #303133;
}
.contents {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 1px 4px rgba(0,0,0,.06);
    min-width: 0;
    overflow: hidden;
}
.contenttext {
    display: flex;
    flex-direction: column;
    min-width: 0;
}
.inputtext {
    margin: 0 0 8px 0;
    font-size: 14px;
    color: #606266;
}
.num-chars { color: #409eff; }
.num-coins { color: #e6a23c; }
.uploadclass {
    margin-bottom: 16px;
}
.wenben.result-area {
    width: 100%;
    max-width: 100%;
    min-height: 200px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    font-size: 14px;
    resize: vertical;
    box-sizing: border-box;
}
.wenben.result-area:focus {
    border-color: #409eff;
    outline: none;
}
.btn {
    margin-top: 12px;
}
.right {
    margin-left: 20px;
    width: 320px;
    flex-shrink: 0;
}
.collapse-title-with-icon .el-icon-s-flag {
    margin-left: 8px;
    margin-right: 6px;
}
.collapse-title-with-icon { font-weight: bold; }
.select {
    width: 100%;
}
.right-tip {
    margin-top: 16px;
    padding: 12px;
    background: #f5f7fa;
    border-radius: 6px;
}
.toptip {
    margin-top: 24px;
    font-size: 13px;
    color: #606266;
}
.tishi {
    font-weight: 600;
    margin-bottom: 8px;
    color: #303133;
}
.tishitip {
    margin-bottom: 6px;
    line-height: 1.5;
}
.qqtext { margin-bottom: 10px; }
@media (max-width: 768px) {
    .tts { flex-direction: column; }
    .right { margin-left: 0; margin-top: 16px; width: 100%; }
}
</style>

<!-- 暗黑模式适配 -->
<style lang="less">
.dark-mode .main .tts {
    .contents {
        background: var(--bg-card) !important;
        box-shadow: 0 1px 4px var(--shadow-color) !important;
        min-width: 0;
        overflow: hidden;
    }
    .nav .active { color: var(--text-primary) !important; }
    .inputtext { color: var(--text-regular) !important; }
    .wenben.result-area {
        background: var(--input-bg) !important;
        color: var(--text-primary) !important;
        border-color: var(--border-color) !important;
        max-width: 100%;
        box-sizing: border-box;
        &:focus { border-color: #409eff !important; }
    }
}
.dark-mode .right-tip {
    background: var(--bg-secondary) !important;
    color: var(--text-regular) !important;
}
.dark-mode .toptip {
    color: var(--text-regular) !important;
}
.dark-mode .right-tip .tishi,
.dark-mode .toptip .tishi { color: var(--text-primary) !important; }
.dark-mode .right-tip .tishitip,
.dark-mode .toptip .tishitip { color: var(--text-regular) !important; }
</style>
